import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type CheckoutResumeFromOnHold = {
  orderId: number;
  addresses?: Array<Record<string, unknown>>;
  shoppingMode?: string;
  pickupLocation?: string;
  poNumber?: string;
} | null;

const initialCheckoutResume: CheckoutResumeFromOnHold = null;

const orderSlice = createSlice({
  name: "order",
  initialState: {
    orders: [],
    order: null,
    error: null,
    loading: false,
    applyCoupon: null,
    shippingRates: null,
    addons: [],
    /** When paying for an existing on-hold order, checkout + payment use this id */
    checkoutResumeFromOnHold: initialCheckoutResume as CheckoutResumeFromOnHold,
  },
  reducers: {
    createOrderAction: (state, payload) => {
      state.loading = true;
      state.error = null;
    },
    createOrderSuccess: (state, action) => {
      state.orders = action.payload.data || [];
      state.loading = false;
    },
    createOrderFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    getOrderByIDAction: (state, action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    getOrderByIDSuccess: (state, action) => {
      state.order = action.payload;
      state.loading = false;
    },
    getOrderByIDFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    getOrdersAction: (state) => {
      state.loading = true;
      state.error = null;
    },
    getOrdersSuccess: (state, action) => {
      state.orders = action.payload || [];
      state.loading = false;
    },
    getOrdersFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    getShippingRatesAction: (state, action) => {
      state.error = null;
    },
    getShippingRatesSuccess: (state, action) => {
      state.shippingRates = action.payload;
    },
    getShippingRatesFailure: (state, action) => {
      state.error = action.payload;
    },
    getAddonsAction: (state) => {
      state.error = null;
    },
    getAddonsSuccess: (state, action) => {
      state.addons = action.payload;
    },
    getAddonsFailure: (state, action) => {
      state.error = action.payload;
    },
    setCheckoutResumeFromOnHold: (
      state,
      action: PayloadAction<Exclude<CheckoutResumeFromOnHold, null>>,
    ) => {
      state.checkoutResumeFromOnHold = action.payload;
    },
    clearCheckoutResumeFromOnHold: (state) => {
      state.checkoutResumeFromOnHold = initialCheckoutResume;
    },
  },
});

export const {
  createOrderAction,
  createOrderSuccess,
  createOrderFailure,
  getOrderByIDAction,
  getOrderByIDSuccess,
  getOrderByIDFailure,
  getOrdersAction,
  getOrdersSuccess,
  getOrdersFailure,
  getShippingRatesAction,
  getShippingRatesSuccess,
  getShippingRatesFailure,
  getAddonsAction,
  getAddonsSuccess,
  getAddonsFailure,
  setCheckoutResumeFromOnHold,
  clearCheckoutResumeFromOnHold,
} = orderSlice.actions;

export default orderSlice.reducer;
